// The browser's own error log (Step 29). One JSON line per failure: what
// failed, the error's name and a short code. Never the error's message,
// which could hold what a person typed (team rule: no personal data in logs).
import { ApiError } from './api-client';

export type ClientLog = (where: string, error: unknown) => void;

// The browser console is where an error log line lives in the browser.
const consoleSink = (line: string) => console.error(line);

// An API error's code comes from the response body, which a proxy or a
// faulty server controls. Only a short code that starts with a letter is
// written, so digits alone (a phone number, a sign-in code) never are.
// Anything else could carry personal data and is written as UNEXPECTED
// (Steps 30 and 31).
const SAFE_CODE = /^[A-Z][A-Z0-9_]{0,39}$/;

function safeCodeOf(error: unknown): string {
  const code: unknown = error instanceof ApiError ? error.code : undefined;
  return typeof code === 'string' && SAFE_CODE.test(code) ? code : 'UNEXPECTED';
}

export function logClientError(
  where: string,
  error: unknown,
  sink: (line: string) => void = consoleSink,
): void {
  const errorName = error instanceof Error ? error.name : 'NotAnError';
  const code = safeCodeOf(error);
  sink(JSON.stringify({ level: 'ERROR', message: where, errorName, code }));
}
